import { render } from "./DialogInableToBuy.vue?vue&type=template&id=e56c87e6"
import script from "./DialogInableToBuy.vue?vue&type=script&lang=js"
export * from "./DialogInableToBuy.vue?vue&type=script&lang=js"
script.render = render

export default script